export default __webpack_public_path__ + "static/media/CH0163.77d14be9.png";